// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2PdAs","label":"Category_label__GN9A5","content":"Category_content__SHkEr","header":"Category_header__3xs7M","location":"Category_location__24rBm"};